var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectIdQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      maxWidth: "100%",
      height: "auto"
    },
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h300v300H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.909 18.182h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.182 18.182h9.364v9.364h-9.364z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.273 18.182h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.545 18.182h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M181.818 18.182h9.364v9.364h-9.364zm18.182 0h9.364v9.364H200zM90.909 27.273h9.364v9.364h-9.364z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100 27.273h9.364v9.364H100z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.091 27.273h9.364v9.364h-9.364z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.182 27.273h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.364z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M154.545 27.273h9.364v9.364h-9.364z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M163.636 27.273H173v9.364h-9.364z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.727 27.273h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm-100 9.091h9.364v9.364h-9.364zm36.364 0h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.365z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.636 36.364H173v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M190.909 36.364h9.364v9.364h-9.364z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M200 36.364h9.364v9.364H200zm-90.909 9.091h9.364v9.364h-9.364z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.182 45.455h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M145.455 45.455h9.364v9.364h-9.364z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.545 45.455h9.364v9.364h-9.364z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M163.636 45.455H173v9.364h-9.364z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M172.727 45.455h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zM100 54.546h9.364v9.364H100z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M109.091 54.545h9.364v9.364h-9.364z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M118.182 54.545h9.364v9.364h-9.364z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M127.273 54.545h9.364v9.364h-9.364z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136.364 54.545h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.365zm18.182 0h9.364v9.364h-9.365z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M190.909 54.545h9.364v9.364h-9.364zm-100 9.091h9.364V73h-9.364z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M100 63.636h9.364V73H100zm27.273 0h9.364V73h-9.364zm27.273 0h9.364V73h-9.365z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M163.636 63.636H173V73h-9.364zm18.182 0h9.364V73h-9.364zm-90.909 9.091h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M163.636 72.727H173v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364H200zM90.909 81.818h9.364v9.364h-9.364z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100 81.818h9.364v9.364H100zm18.182 0h9.364v9.364h-9.364z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M127.273 81.818h9.364v9.364h-9.364z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M136.364 81.818h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M163.636 81.818H173v9.364h-9.364zm27.273 0h9.364v9.364h-9.364zM36.364 90.909h9.364v9.364h-9.364z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M45.455 90.909h9.364v9.364h-9.364z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54.545 90.909h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M100 90.909h9.364v9.364H100zm27.273 0h9.364v9.364h-9.364z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M136.364 90.909h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365zm27.273 0h9.364v9.364h-9.365zm27.273 0h9.364v9.364h-9.365z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M218.182 90.909h9.364v9.364h-9.364z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M227.273 90.909h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.365z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M263.636 90.909H273v9.364h-9.364z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M272.727 90.909h9.364v9.364h-9.364zM27.273 100h9.364v9.364h-9.364z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M36.364 100h9.364v9.364h-9.364zm45.455 0h9.364v9.364h-9.365zm18.182 0h9.364v9.364H100z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M109.091 100h9.364v9.364h-9.364z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M118.182 100h9.364v9.364h-9.364z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M127.273 100h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M154.545 100h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm36.364 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M236.364 100h9.364v9.364h-9.364z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M245.455 100h9.364v9.364h-9.364z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M254.545 100h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm-245.454 9.091h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.365z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M63.636 109.091H73v9.364h-9.364z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M72.727 109.091h9.364v9.364h-9.364z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M81.818 109.091h9.364v9.364h-9.364z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M90.909 109.091h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.364z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M145.455 109.091h9.364v9.364h-9.364z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M154.545 109.091h9.364v9.364h-9.364z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M163.636 109.091H173v9.364h-9.364zm36.364 0h9.364v9.364H200z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M209.091 109.091h9.364v9.364h-9.364z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M218.182 109.091h9.364v9.364h-9.364zm36.364 0h9.364v9.364h-9.365zm-209.091 9.091h9.364v9.364h-9.364zm36.364 0h9.364v9.364h-9.365z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M90.909 118.182h9.364v9.364h-9.364z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M100 118.182h9.364v9.364H100z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M109.091 118.182h9.364v9.364h-9.364zm45.455 0h9.364v9.364h-9.365zm18.182 0h9.364v9.364h-9.365zm27.273 0h9.364v9.364H200z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M209.091 118.182h9.364v9.364h-9.364z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M218.182 118.182h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M245.455 118.182h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365zm-236.364 9.091h9.364v9.364h-9.364z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M36.364 127.273h9.364v9.364h-9.364z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M45.455 127.273h9.364v9.364h-9.364z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M54.545 127.273h9.364v9.364h-9.364z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M63.636 127.273H73v9.364h-9.364z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M72.727 127.273h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm45.455 0h9.364v9.364h-9.364z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M145.455 127.273h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365zm36.364 0h9.364v9.364H200z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M209.091 127.273h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.365z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M263.636 127.273H273v9.364h-9.364z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M272.727 127.273h9.364v9.364h-9.364zm-254.545 9.091h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M45.455 136.364h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365zm18.182 0h9.364v9.364h-9.365zm18.182 0h9.364v9.364H100z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M109.091 136.364h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.365zm27.273 0h9.364v9.364h-9.365z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M190.909 136.364h9.364v9.364h-9.364z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M200 136.364h9.364v9.364H200z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M209.091 136.364h9.364v9.364h-9.364z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M218.182 136.364h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M245.455 136.364h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M272.727 136.364h9.364v9.364h-9.364zm-209.091 9.091H73v9.364h-9.364z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M72.727 145.455h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm36.364 0h9.364v9.364h-9.364zm72.727 0h9.364v9.364H200zm27.273 0h9.364v9.364h-9.364zm-209.091 9.09h9.364v9.364h-9.364z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M27.273 154.545h9.364v9.364h-9.364z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M36.364 154.545h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M63.636 154.545H73v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M90.909 154.545h9.364v9.364h-9.364z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M100 154.545h9.364v9.364H100z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M109.091 154.545h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.365zm81.818 0h9.364v9.364h-9.364z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M245.455 154.545h9.364v9.364h-9.364zm-227.273 9.091h9.364V173h-9.364zm18.182 0h9.364V173h-9.364z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M45.455 163.636h9.364V173h-9.364z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M54.545 163.636h9.364V173h-9.364z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M63.636 163.636H73V173h-9.364z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M72.727 163.636h9.364V173h-9.364z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M81.818 163.636h9.364V173h-9.364zm27.273 0h9.364V173h-9.364z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M118.182 163.636h9.364V173h-9.364zm18.182 0h9.364V173h-9.364z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M145.455 163.636h9.364V173h-9.364zm36.364 0h9.364V173h-9.365zm54.545 0h9.364V173h-9.364z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M245.455 163.636h9.364V173h-9.364z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M254.545 163.636h9.364V173h-9.364z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M263.636 163.636H273V173h-9.364z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M272.727 163.636h9.364V173h-9.364zm-254.545 9.091h9.364v9.364h-9.364z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M27.273 172.727h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.365z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M63.636 172.727H73v9.364h-9.364zm27.273 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm54.545 0H173v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M190.909 172.727h9.364v9.364h-9.364z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M200 172.727h9.364v9.364H200z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M209.091 172.727h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M236.364 172.727h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M263.636 172.727H273v9.364h-9.364z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M272.727 172.727h9.364v9.364h-9.364zm-254.545 9.091h9.364v9.364h-9.364zm36.364 0h9.364v9.364h-9.365z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M63.636 181.818H73v9.364h-9.364z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M72.727 181.818h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M100 181.818h9.364v9.364H100zm18.182 0h9.364v9.364h-9.364z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M127.273 181.818h9.364v9.364h-9.364z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M136.364 181.818h9.364v9.364h-9.364zm45.455 0h9.364v9.364h-9.365zm36.364 0h9.364v9.364h-9.365zm27.273 0h9.364v9.364h-9.365z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M254.545 181.818h9.364v9.364h-9.364zm-236.363 9.091h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365zm36.364 0h9.364v9.364h-9.365zm18.182 0h9.364v9.364h-9.365zm18.182 0h9.364v9.364h-9.365z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M136.364 190.909h9.364v9.364h-9.364z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M145.455 190.909h9.364v9.364h-9.364z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M154.545 190.909h9.364v9.364h-9.364zm36.364 0h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.364z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M227.273 190.909h9.364v9.364h-9.364z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M236.364 190.909h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.365z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M272.727 190.909h9.364v9.364h-9.364zM18.182 200h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M72.727 200h9.364v9.364h-9.364z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M81.818 200h9.364v9.364h-9.364z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M90.909 200h9.364v9.364h-9.364zm36.364 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M154.545 200h9.364v9.364h-9.364z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M163.636 200H173v9.364h-9.364zm27.273 0h9.364v9.364h-9.364z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M200 200h9.364v9.364H200z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M209.091 200h9.364v9.364h-9.364z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M218.182 200h9.364v9.364h-9.364z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M227.273 200h9.364v9.364h-9.364z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M236.364 200h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365zM90.91 209.091h9.364v9.364h-9.365zm18.182 0h9.364v9.364h-9.365z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M118.182 209.091h9.364v9.364h-9.364z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M127.273 209.091h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M154.545 209.091h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M181.818 209.091h9.364v9.364h-9.364z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M190.909 209.091h9.364v9.364h-9.364z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M200 209.091h9.364v9.364H200zm36.364 0h9.364v9.364h-9.364z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M245.455 209.091h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M272.727 209.091h9.364v9.364h-9.364zm-163.636 9.091h9.364v9.364h-9.364z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M118.182 218.182h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.364z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M154.545 218.182h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.364z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M190.909 218.182h9.364v9.364h-9.364z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M200 218.182h9.364v9.364H200zm18.182 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zM100 227.273h9.364v9.364H100z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M109.091 227.273h9.364v9.364h-9.364zm45.455 0h9.364v9.364h-9.365zm36.364 0h9.364v9.364h-9.365z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M200 227.273h9.364v9.364H200zm36.364 0h9.364v9.364h-9.364z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M245.455 227.273h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365zM90.91 236.364h9.364v9.364h-9.365z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M100 236.364h9.364v9.364H100z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M109.091 236.364h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.365z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M163.636 236.364H173v9.364h-9.364z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M172.727 236.364h9.364v9.364h-9.364zm27.273 0h9.364v9.364H200z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M209.091 236.364h9.364v9.364h-9.364z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M218.182 236.364h9.364v9.364h-9.364z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M227.273 236.364h9.364v9.364h-9.364z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M236.364 236.364h9.364v9.364h-9.364z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M245.455 236.364h9.364v9.364h-9.364z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M254.545 236.364h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm-181.818 9.091h9.364v9.364h-9.364z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M100 245.455h9.364v9.364H100z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M109.091 245.455h9.364v9.364h-9.364z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M118.182 245.455h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.365zm18.182 0h9.364v9.364h-9.365z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M190.909 245.455h9.364v9.364h-9.364z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M200 245.455h9.364v9.364H200z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M209.091 245.455h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M254.545 245.455h9.364v9.364h-9.364zm-163.636 9.091h9.364v9.364h-9.364z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M100 254.545h9.364v9.364H100zm45.455 0h9.364v9.364h-9.364zm36.364 0h9.364v9.364h-9.365z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M190.909 254.545h9.364v9.364h-9.364z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M200 254.545h9.364v9.364H200z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M209.091 254.545h9.364v9.364h-9.364z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M218.182 254.545h9.364v9.364h-9.364z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M227.273 254.545h9.364v9.364h-9.364z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M236.364 254.545h9.364v9.364h-9.364z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M245.455 254.545h9.364v9.364h-9.364z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M254.545 254.545h9.364v9.364h-9.364z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M263.636 254.545H273v9.364h-9.364zm-154.545 9.091h9.364V273h-9.364zm27.273 0h9.364V273h-9.364z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M145.455 263.636h9.364V273h-9.364zm18.182 0h9.364V273h-9.365zm27.273 0h9.364V273h-9.365z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M200 263.636h9.364V273H200z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M209.091 263.636h9.364V273h-9.364z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M218.182 263.636h9.364V273h-9.364zm18.182 0h9.364V273h-9.364z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M245.455 263.636h9.364V273h-9.364zm18.182 0h9.364V273h-9.365zm-154.545 9.091h9.364v9.364h-9.365z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M118.182 272.727h9.364v9.364h-9.364zm36.364 0h9.364v9.364h-9.365z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M163.636 272.727H173v9.364h-9.364z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M172.727 272.727h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zm27.273 0h9.364v9.364h-9.364zm18.182 0h9.364v9.364h-9.364zM18.182 18.182v63.636h63.636V18.182zm54.545 54.545H27.273V27.273h45.455zm145.455-54.545v63.636h63.636V18.182zm54.545 54.545h-45.454V27.273h45.455zM18.182 218.182v63.636h63.636v-63.636zm54.545 54.545H27.273v-45.454h45.455z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M36.364 36.364h27.273v27.273H36.364zm200 0h27.273v27.273h-27.273zm-200 200h27.273v27.273H36.364z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIdQr);
export default __webpack_public_path__ + "static/media/ConnectID_QR.985a055282bb23fe1aaa0a22e0cac81d.svg";
export { ForwardRef as ReactComponent };